// You should import getters from store
// ...mapGetters([
//     'chessSettings',
//     'infoSettings',
//     'interactiveSettings',
//     'premisesSettings',
//     'catalogs',
//     'estates',
//     'project',
// ])

export default {
  computed: {
    chessRoute() {
      let name = 'ChessPlus';
      let params = {};
      if (!this.chessSettings?.plus.enabled) {
        name = 'Chess';
      }
      if (this.project?.type != 2 && this.estates.length > 1) {
        name += 'WithEstate';
        params.estateId = this.estates[0].id;
      }
      return {
        name: name,
        params: params,
      };
    },
    menuItems() {
      return [
        {
          key: 'Projects',
          show: this.catalogs?.show_page,
          route: { name: 'Projects' },
          icon: 'LayoutList',
          inert: this.$route.name === 'Projects',
          active: this.$route.name == 'Projects',
        },
        {
          key: `Interactive-${this.interactiveSettings?.translate}`,
          show: this.interactiveSettings?.enabled,
          route: {
            name: 'Interactive',
            params: {
              frameId: this.interactiveSettings?.default_frame_id,
              interactiveId: this.interactiveSettings?.default_id,
            },
          },
          icon: 'Interactive',
          active: this.$route.name.startsWith('Interactive'),
          emitClick: true,
        },
        {
          key: 'Premises',
          show: this.premisesSettings?.enabled,
          route: { name: 'Premises' },
          icon: 'PremisesLayout',
          inert: this.$route.name.startsWith('Premises'),
          active: this.$route.name.startsWith('Premises'),
        },
        {
          key: 'Chess',
          show:
            this.chessSettings?.common.enabled ||
            this.chessSettings?.plus.enabled,
          route: this.chessRoute,
          icon: 'Grid2x2Plus',
          inert: this.$route.name.startsWith('Chess'),
          active: this.$route.name.startsWith('Chess'),
        },
        {
          key: 'About',
          show: this.infoSettings?.enabled,
          route: { name: 'Info' },
          icon: 'FileText',
          inert: this.$route.name === 'Info',
          active: this.$route.name === 'Info',
        },
      ];
    },
  },
};
